import { StatusBadge } from "@molecules"

import styles from "./StatusCell.module.scss"
import { StatusCellProps } from "./StatusCell.types"

export default function StatusCell(props: StatusCellProps) {
    const { status, dateDue, dotStatusOverride } = props

    return (
        <div className={styles.base}>
            <StatusBadge status={status} dateDue={dateDue} dotStatusOverride={dotStatusOverride} />
        </div>
    )
}
